
    <!--
 * 横版-活动头图
 * @LastEditTime: Fri Apr 04 2025 19:11:26 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_KPGV409"  :class="[`normal`,`u_c_KPGV409`]" ></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const curRouterCompMap = inject("curRouterCompMap",{});
    const COMP_DATA_LANG = {"default":{},"en-US":{},"th-TH":{},"ru-RU":{}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '活动头图';

    // 自定义setup - 开始
    ;
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_KPGV409.normal{
position:fixed;
width:100%;
height:100%;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/04/1743564355336-77.jpeg);
margin:auto;
font-size:0;
top:0;
left:0;
right:0;
overflow:hidden;

}
}.en-US{
.u_c_KPGV409.normal{
position:fixed;
width:100%;
height:100%;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/04/1743564355336-77.jpeg);
margin:auto;
font-size:0;
top:0;
left:0;
right:0;
overflow:hidden;

}
}.th-TH{
.u_c_KPGV409.normal{
position:fixed;
width:100%;
height:100%;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/04/1743564355336-77.jpeg);
margin:auto;
font-size:0;
top:0;
left:0;
right:0;
overflow:hidden;

}
}.ru-RU{
.u_c_KPGV409.normal{
position:fixed;
width:100%;
height:100%;
background:no-repeat top;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/04/1743564355336-77.jpeg);
margin:auto;
font-size:0;
top:0;
left:0;
right:0;
overflow:hidden;

}
}
</style>
